const generateRandomNumber = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

const IMAGE_SIZES = {
  image: { maxWidth: 1000, maxHeight: 1000 },
  thumbnail: { maxWidth: 300, maxHeight: 300 },
  medium: { maxWidth: 600, maxHeight: 600 },
};

const MAX_WEBP_SIZE = 400 * 1024; // 400KB
const DEFAULT_QUALITY = 0.7;

export const compressImage = (
  file,
  subCategory,
  isIOS = false,
  type = "image",
  fileName = "random"
) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const { maxWidth, maxHeight } = IMAGE_SIZES[type] || IMAGE_SIZES.image;

        let width = img.width;
        let height = img.height;
        const aspectRatio = width / height;

        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            width = maxWidth;
            height = maxWidth / aspectRatio;
          } else {
            height = maxHeight;
            width = maxHeight * aspectRatio;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        // Dosya adını belirle
        let outputFileName;
        if (fileName === "random") {
          const subCategoryName = subCategory
            .toLowerCase()
            .replace(/\s+/g, "_");
          const randomNumber = generateRandomNumber();
          outputFileName = `${subCategoryName}_${type}_${randomNumber}`;
        } else {
          // Uzantıyı kaldır (eğer varsa)
          outputFileName = fileName.replace(/\.[^/.]+$/, "");
        }

        // iOS cihazlar için direkt JPG
        if (isIOS) {
          canvas.toBlob(
            (jpgBlob) => {
              resolve(
                new File([jpgBlob], `${outputFileName}.jpg`, {
                  type: "image/jpeg",
                })
              );
            },
            "image/jpeg",
            DEFAULT_QUALITY
          );
          return;
        }

        // Diğer cihazlar için WebP dene
        canvas.toBlob(
          async (webpBlob) => {
            if (webpBlob.size <= MAX_WEBP_SIZE) {
              // WebP başarılı
              resolve(
                new File([webpBlob], `${outputFileName}.webp`, {
                  type: "image/webp",
                })
              );
            } else {
              // WebP çok büyük, JPG'ye dön
              canvas.toBlob(
                (jpgBlob) => {
                  resolve(
                    new File([jpgBlob], `${outputFileName}.jpg`, {
                      type: "image/jpeg",
                    })
                  );
                },
                "image/jpeg",
                DEFAULT_QUALITY
              );
            }
          },
          "image/webp",
          DEFAULT_QUALITY
        );
      };
    };
  });
};
